module.exports = __webpack_public_path__ + "assets/media/day12.a69f3b75.mp3";